// src/relativeTime.ts
var enFallback = (key, opts) => {
  const n = opts?.count ?? 0;
  switch (key) {
    case "relative.now":
      return "now";
    case "relative.justNow":
      return "just now";
    case "relative.today":
      return "Today";
    case "relative.yesterday":
      return "Yesterday";
    case "relative.expired":
      return "Expired";
    // compact ("5m ago")
    case "relative.minutesAgoShort":
      return `${n}m ago`;
    case "relative.hoursAgoShort":
      return `${n}h ago`;
    case "relative.daysAgoShort":
      return `${n}d ago`;
    case "relative.monthsAgoShort":
      return `${n}mo ago`;
    // compact, no suffix ("5m")
    case "relative.minutesCompact":
      return `${n}m`;
    case "relative.hoursCompact":
      return `${n}h`;
    case "relative.daysCompact":
      return `${n}d`;
    case "relative.weeksCompact":
      return `${n}w`;
    // full words, pluralized
    case "relative.minutesAgo":
      return n === 1 ? "1 minute ago" : `${n} minutes ago`;
    case "relative.hoursAgo":
      return n === 1 ? "1 hour ago" : `${n} hours ago`;
    case "relative.daysAgo":
      return n === 1 ? "1 day ago" : `${n} days ago`;
    case "relative.monthsAgo":
      return n === 1 ? "1 month ago" : `${n} months ago`;
    default:
      return key;
  }
};
var TR_KEY = "__maatRelativeTranslate";
var g = globalThis;
var setRelativeTranslate = (fn) => {
  g[TR_KEY] = fn;
};
var tRelative = (key, opts) => (g[TR_KEY] ?? enFallback)(key, opts);

export {
  setRelativeTranslate,
  tRelative
};
